/* eslint-disable @typescript-eslint/no-var-requires */
const ics = require('ics');
const moment = require('moment');
require('moment-timezone');
import * as Sentry from '@sentry/react';

const generateOfficeHoursICal = (booking) => {
    let events = [];

    const m = moment.tz(booking.date, 'YYYY-MM-DDTHH:mm:ss', 'America/Vancouver');
    const date = m.utc();

    const day = date.format('D');
    const month = date.format('MM');
    const year = date.format('YYYY');

    const timeIn = moment(booking.timeIn, 'HH:mm:ss');
    const timeOut = moment(booking.timeOut, 'HH:mm:ss');

    const hour = timeIn.format('HH');
    const minute = timeIn.format('mm');
    const duration = timeOut.diff(timeIn, 'minutes');
    
    events.push({
        uid: `${booking.ohId}_${booking.timeSlotIndex}`,
        title: `Office Hours Appointment`,
        location: `${booking.location}`,
        description: booking.note,
        start: [parseInt(year), parseInt(month), parseInt(day), parseInt(hour), parseInt(minute)],
        duration: {minutes: parseInt(duration)},
        startType: 'utc'
    });

    const {error, value} = ics.createEvents(events);

    if (error) {
        Sentry.captureException(error, (scope) => {
            scope.setContext('booking', booking);
            return scope;
        });
        return;
    }

    const localUrl = window.URL.createObjectURL(new Blob([value]));
    const link = document.createElement('a');
    link.href = localUrl;
    link.setAttribute('download', 'download.ics');
    document.body.appendChild(link);
    link.click();

    // return window.open('data:text/calendar;charset=utf8,' + escape(value));
};

export default generateOfficeHoursICal;
